import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRightSmall } from '@peacecover/icon';
import { useGetFanLetters } from '../../../domains/bettie/ui/hooks/useGetFanLetters';
import { attachJosa } from '../../../utils/bettieUtils';

const BettieLetterEntryCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: unseenFanLetters } = useGetFanLetters({ only_unseen: true });
  const { data: fanLetters } = useGetFanLetters({ only_unseen: false });

  const hasFanLetters = fanLetters && fanLetters?.length > 0;
  const checkAllLetters = !unseenFanLetters || unseenFanLetters?.length === 0;

  const renderDescription = () => {
    if (!hasFanLetters) {
      return t('ChatPage.bettieLetterEntryCard.emptyLetter');
    }

    if (checkAllLetters) {
      return t('ChatPage.bettieLetterEntryCard.checkAllLetters');
    }

    if (unseenFanLetters?.length === 1) {
      return t('ChatPage.bettieLetterEntryCard.letterSent', {
        nickname: attachJosa(unseenFanLetters[0].bettieNickname ?? '', '가/이가')
      });
    }

    if (unseenFanLetters?.length >= 2) {
      return t('ChatPage.bettieLetterEntryCard.letterSentByOthers', {
        nickname: unseenFanLetters[0].bettieNickname,
        count: unseenFanLetters?.length - 1
      });
    }
  };

  const handleClick = () => {
    if (checkAllLetters) {
      navigate('/bettie/letters');
      return;
    }

    if (unseenFanLetters?.length === 1 && unseenFanLetters[0].fanLetterId) {
      navigate(`/bettie/letter/${unseenFanLetters[0].fanLetterId}`);
      return;
    }

    navigate('/bettie/letters');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex items-center gap-[12px] px-[20px] py-[12px] w-full"
    >
      <div
        className="relative w-[46px] h-[46px] flex-shrink-0 rounded-full"
        style={{
          background:
            'linear-gradient(0deg, rgba(255, 255, 255, 0.68) 0%, rgba(255, 255, 255, 0.68) 100%), radial-gradient(50% 50% at 50% 50%, #FFF 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #FFEFB5 0deg, #EAB0FA 102.59999871253967deg, #90ECFF 232.19999313354492deg, #FFEFB5 360deg)'
        }}
      >
        <img
          src="/assets/bettie/bettie_letter.png"
          alt="bettie letter"
          className="w-[28px] h-[23px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
        />
      </div>
      <div className="flex items-center justify-between w-full">
        <div className="flex flex-col items-start gap-[4px]">
          <p className="text-[15px] font-semibold text-text-main-lv2 leading-[18px]">
            {t('ChatPage.bettieLetterEntryCard.title')}
          </p>
          <p className="text-[13px] text-text-main-lv3 leading-[16px] text-left">
            {renderDescription()}
          </p>
        </div>
      </div>
      {checkAllLetters ? (
        <ArrowRightSmall size={20} className="text-text-main-lv4" />
      ) : (
        <div className="flex items-center bg-gradient-multi-rainbox-lv1 rounded-[19px] pl-[8px] pr-[3px] pt-[4px] pb-[3px] flex-shrink-0">
          <span className="text-[11px] font-semibold bg-gradient-single-red bg-clip-text text-transparent leading-[13px]">
            {t('ChatPage.bettieLetterEntryCard.button')}
          </span>
          <ArrowRightSmall
            size={12}
            gradientStops={[
              { offset: '0%', color: '#FF45A9' },
              { offset: '100%', color: '#FF6A6A' }
            ]}
          />
        </div>
      )}
    </button>
  );
};

export default BettieLetterEntryCard;
